<template>
  <div class="taking">
    <div class="steps">
      <div :data-selected="current === 0" class="step">
        <div class="num">1</div>
        <div class="name">{{ steps[0].text }}</div>
      </div>
      <div class="divider"></div>
      <div :data-selected="current === 1" class="step">
        <div class="num">2</div>
        <div class="name">{{ steps[1].text }}</div>
      </div>
      <div class="divider"></div>
      <div :data-selected="current === 2" class="step">
        <div class="num">3</div>
        <div class="name">{{ steps[2].text }}</div>
      </div>
    </div>

    <div class="info">
      <div class="row">
        <div
          v-for="(item, index) in infos"
          :key="'info-' + index"
          class="info-item"
        >
          <img :src="item.image" />
          <div>{{ item.text }}</div>
        </div>
      </div>
      <button @click="showTakinngHint(current)">拍摄内容须知</button>
    </div>
    <div class="fill"></div>
    <div class="taking-info2">
      请用当前手机点击下方“开始拍摄”拍摄被保障手机
    </div>
    <input
      ref="pic"
      type="file"
      capture="camera"
      accept="image/*"
      @change="fileChange"
    />
  </div>
</template>

<script>
import lrz from "lrz";
export default {
  name: "ActiveTakingPictures",
  inject: ["injectStepInfo", "showTakinngHint","updateNextText"],
  data() {
    return {
      isWechat: this.$store.state.isWechat,
      steps: [
        { type: "imei", text: "IMEI码拍摄",takeText:"拍摄IMEI码" },
        { type: "screenClose", text: "正面熄屏拍摄", takeText:"拍摄正面熄屏"  },
        { type: "back", text: "背面拍摄", takeText:"拍摄背面"  },
      ],
      infos: [
        {
          image: require("../../assets/ic_clear_focus.png"),
          text: "对焦清晰",
        },
        {
          image: require("../../assets/ic_keep_level.png"),
          text: "保持水平",
        },
        {
          image: require("../../assets/ic_complete_filming.png"),
          text: "完整拍摄",
        },
      ],
      current: 0,
      callback: null,
    };
  },
  mounted() {
    this.injectStepInfo.images = {
      imei: null,
      screenClose: null,
      back: null,
    };
    this.updateNextText(this.steps[0].takeText)
  },
  watch:{
    current(value){
      if(value < this.steps.length) {
        this.updateNextText(this.steps[value].takeText)
      }
    }
  },
  methods: {
    async nextStep() {
      // if (!this.isWechat) {
      //   this.$toast("请在微信中使用该功能");
      //   return false;
      // }
      try {
        let res = await this.takingPic();
        this.injectStepInfo.images[this.steps[this.current].type] = res;
        this.current = this.current + 1;
      } catch (e) {
        console.log(e);
      }
      return this.current > 2;
    },
    async fileChange(e) {
      if (e.target.files.length > 0) {
        const file = e.target.files[0];
        const res = await lrz(file, {
          width: 720,
          ingnoreOrientation: true,
        });
        this.callback && this.callback.resolve(res.base64);
      } else {
        this.callback && this.callback.reject("not choose");
        this.callback = null;
      }
    },
    dataURLtoFile(dataurl, filename) {
      // 将base64转换为file文件
      // 参数dataurl base64字符串
      // 参数filename	图片名称
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime,
      });
    },
    async takingPic() {
      this.$refs.pic.click();
      return new Promise((resolve, reject) => {
        this.callback = { resolve, reject };
      });
    },
  },
};
</script>

<style lang="less" scoped>
.taking {
  background: #f4f4f4;
  width: 100%;
  height: calc(100% - 56px - env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 12px;
}
.steps {
  display: flex;
  width: 100%;
  margin-top: 38px;
  padding: 0 16px;
  box-sizing: border-box;
  .step {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    .num {
      width: 32px;
      height: 32px;
      background: white;
      border-radius: 16px;
      font-size: 16px;
      line-height: 32px;
      text-align: center;
      color: #000000;
      font-weight: 500;
    }
    .name {
      font-size: 14px;
      font-weight: 400;
      color: black;
      margin-top: 7px;
      text-align: center;
    }

    &[data-selected] .num {
      background: linear-gradient(90deg, #f4e4cc, #f0c587);
      color: #4d3621;
    }
  }
  .divider {
    width: 34px;
    height: 1px;
    background: #4c4c4c;
    margin-top: 16px;
  }
}

.info {
  background: white;
  width: 100%;
  border-radius: 8px;
  padding: 32px;
  margin: 35px 12px;
  box-sizing: border-box;
  text-align: center;
  .row {
    display: flex;
    justify-content: space-between;
    .info-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: #333333;
      img {
        height: 25px;
        margin-bottom: 8px;
      }
    }
  }
  button {
    height: 30px;
    width: 157px;
    background: transparent;
    border: 1px solid #e3e3e3;
    border-radius: 15px;
    font-size: 13px;
    line-height: 30px;
    text-align: center;
    margin-top: 27px;
  }
}
.fill {
  flex: 1 1;
}

.taking-info2 {
  margin-bottom: 12px;
  width: 240px;
  font-size: 13px;
  text-align: center;
}

input[type="file"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  overflow: hidden;
}
</style>
